import { render, staticRenderFns } from "./Consultarreceta.vue?vue&type=template&id=1adba0bc"
import script from "./Consultarreceta.vue?vue&type=script&lang=js"
export * from "./Consultarreceta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports